import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PopiManagerService } from '../../../../../service/proxy';
import { Router } from '@angular/router';
import { ToastService } from '../../../../shared/toast/toast.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { LoadingHelper } from '../../../../shared/services/loading-helper';

@Component({
    standalone: true,
    selector: 'app-popi-list',
    templateUrl: './popi-list.component.html',
    styleUrls: ['./popi-list.component.scss'],

    imports: [
        CommonModule
    ],

    providers: [
        PopiManagerService,
        ToastService
    ]
})
export class PopiListComponent implements OnInit {
    public mappings: any[] = [];
    public isLoading = true;

    constructor(
        private popiService: PopiManagerService,
        private toastService: ToastService,
        private router: Router,
        private loadingService: LoadingService
    ) {}

    ngOnInit(): void {
        this.loadMappings();
    }

    loadMappings() {
        LoadingHelper.withLoading(
            this.popiService.getAllEntityMappings(),
            this.loadingService
        ).subscribe({
            next: (data) => {
                this.mappings = data || [];
                this.isLoading = false;
            },
            error: (err) => {
                this.isLoading = false;
                this.toastService.show('Failed to load entity mappings.', 'error');
            }
        });
    }

    deleteMapping(mapping: any) {
        if (!confirm(`Are you sure you want to delete the mapping for ${mapping.displayName}?`)) {
            return;
        }

        LoadingHelper.withLoading(
            this.popiService.deleteEntityMapping(mapping.id),
            this.loadingService
        ).subscribe({
            next: () => {
                this.mappings = this.mappings.filter(m => m.id !== mapping.id);
                this.toastService.show('Mapping deleted successfully.', 'success');
            },
            error: (err) => {
                this.toastService.show('Failed to delete mapping.', 'error');
            }
        });
    }

    goToEdit(mapping: any) {
        this.router.navigate(['/popi/mappings/create-or-update'], {
            queryParams: {
                id: mapping.id
            }
        });
    }

    createMapping(): void {
        this.router.navigate(['/popi/mappings/create-or-update'], {
            queryParams: {
                id: 0
            }
        });
    }

    goBack() {
        this.router.navigate(['/popi']);
    }
}
